import { Button, TableCell } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { AggregateScoresNode } from "~/components/FirewatchPage";
import { isSpaceOrWorkspaceScope, useScope } from "~/hooks/useScope";
import { FindingTableTriageCell } from "~/pages/inventory/components/Findings/FindingsTable/FindingTableTriageCell";
import { getStatusDisplay } from "~/components/FirewatchRow/Cells/firewatchTableCellUtils";
import { CVEFindingsNode } from "~/pages/inventory/components/AssetSoftwareDetails/AssetSoftwareVulnerabilities/hooks/types";
import { AdvisoryFindingsNode } from "~/pages/inventory/components/Findings/FindingsTable/utils/advisoryTypes";
import { CheckFindingsCheckNode } from "~/pages/inventory/asset/types";
import { ExposedAsset } from "~/pages/space/vulnerabilities/components/exposed-assets/types";

interface ActionCellProps {
  row:
    | CVEFindingsNode
    | AdvisoryFindingsNode
    | CheckFindingsCheckNode
    | AggregateScoresNode
    | ExposedAsset;
  scopeMrn?: string;
}

export const ActionCell = ({ row, scopeMrn }: ActionCellProps) => {
  const { spaceScope, activeScope } = useScope();
  const status = getStatusDisplay({
    exception: row?.exception,
    cases:
      "openCases" in row
        ? row.openCases?.edges
        : "cases" in row
          ? row.cases?.edges
          : undefined,
    scope: isSpaceOrWorkspaceScope(activeScope) ? activeScope : undefined,
    spaceScope: spaceScope,
  });

  if (!status) {
    return (
      <FindingTableTriageCell
        finding={row}
        type="action-cell"
        scopeMrn={scopeMrn}
      />
    );
  }

  return (
    <TableCell sx={{ whiteSpace: "nowrap" }}>
      <Button
        component={RouterLink}
        to={status.url || ""}
        startIcon={status.icon}
        variant="text"
        size="small"
        onClick={(e) => e.stopPropagation()}
        sx={{
          // if there is an active exception, the text should color should be disabled
          color: row.exception ? "text.secondary" : "text.primary",
          textWrap: "nowrap",
          height: 30,
        }}
      >
        {status.genericLabel}
      </Button>
    </TableCell>
  );
};
